import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalVariable } from '../globals';

@Injectable({
  providedIn: 'root'
})
export class EstimateDetailsDownloadService {

  // private apiUrl = 'https://iapi.testpitstop.com/v1.0/pitstopspare/api/v1/service/downloadPdfDetails';
  private apiUrl = `${GlobalVariable.BASE_API_URL}/api/v1/service/downloadPdfDetails`;


  constructor(private http: HttpClient) {}

  // downloadPdfDetails(): Observable<any> {
  //   // Get vehicleData from localStorage
  //   const vehicleDataString = localStorage.getItem('vehicleData');
  //   let registrationNumber = '';
  //   let variantKey = '';
  //   let carSize = '';

  //   if (vehicleDataString) {
  //     const vehicleData = JSON.parse(vehicleDataString);
  //     registrationNumber = vehicleData.registrationNumber || '';
  //     variantKey = vehicleData.variantKey || '';
  //     carSize = 'es'; 
  //   }
  //   const garageKey = localStorage.getItem('garageKey') || '';

  //   const payload = {
  //     garageKey: garageKey,
  //     registrationNumber: registrationNumber,
  //     serviceId: 1,
  //     carSize: carSize,
  //     variantKey: variantKey
  //   };

  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json; charset=UTF-8'
  //   });

  //   return this.http.post(this.apiUrl, payload, { headers });
  // }

  downloadPdfDetails(customerName?: string, customerPhoneNumber?: string): Observable<any> {
  const vehicleDataString = localStorage.getItem('vehicleData');
  let registrationNumber = '';
  let variantKey = '';
  let carSize = 'es';

  if (vehicleDataString) {
    const vehicleData = JSON.parse(vehicleDataString);
    registrationNumber = vehicleData.registrationNumber || '';
    variantKey = vehicleData.variantKey || '';
  }

  const garageKey = localStorage.getItem('garageKey') || '';

  const payload = {
    garageKey: garageKey,
    registrationNumber: registrationNumber,
    serviceId: 1,
    carSize: carSize,
    variantKey: variantKey,

    // 👉 Added fields
    customerName: customerName || '',
    customerPhoneNumber: customerPhoneNumber || ''
  };

  return this.http.post(this.apiUrl, payload);
}

}
